<template>
  <b-table
    :items="files"
    :fields="fields"
    :filter="filter"
    :busy.sync="loading"
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    hover
    selectable
    show-empty
    small
    stacked="sm"
    class="files-table"
    @row-selected="onRowSelected">
    <template v-slot:empty>
      <div class="text-muted text-center">
        No files found
      </div>
    </template>
    <template v-slot:table-busy>
      <div class="text-center my-2">
        <b-spinner class="align-middle mr-3" />
        <strong>Loading...</strong>
      </div>
    </template>
    <template v-slot:cell(name)="{item}">
      <b-img
        v-if="!isFolder(item)"
        :src="item.url"
        class="thumbnail"
        @click.stop="preview(item)" />
      <b-img
        v-else
        class="folder-icon thumbnail"
        @click.stop="updatePath(item.url)" />
      <span class="ml-1">
        <b-btn
          variant="link"
          style="font-size: .9rem"
          @click.stop="isFolder(item) ? updatePath(item.url) : preview(item)">
          {{ item.name }}
        </b-btn>
      </span>
    </template>
    <template v-slot:cell(contentType)="{item}">
      {{ item.contentType | formatMIME }}
    </template>
    <template
      v-slot:cell(bytes)="{item}"
      class="text-monospace">
      {{ isFolder(item) ? '- -' : $options.filters.formatSize(item.bytes) }}
    </template>
    <template v-slot:cell(lastModified)="{item}">
      {{ isFolder(item) ? '- -' : $options.filters.formatDate(item.lastModified) }}
    </template>
    <template v-slot:cell(actions)="{item}">
      <div
        v-if="!isFolder(item)"
        class="d-flex justify-content-end flex-wrap flex-lg-nowrap">
        <b-img
          v-b-tooltip.hover
          title="Preview"
          src="/img/icons/preview-icon.svg"
          class="asset-action-icon mx-2 my-1 my-lg-0"
          @click.stop="preview(item)" />
        <b-img
          v-b-tooltip.hover
          title="Copy Link"
          src="/img/icons/copy-icon.svg"
          class="asset-action-icon mx-2 my-1 my-lg-0"
          @click.stop="copyUrl(item.url)" />
        <b-img
          v-b-tooltip.hover
          title="Download"
          src="/img/icons/download-icon.svg"
          class="asset-action-icon mx-2 my-1 my-lg-0"
          @click.stop="download(item.url, item.name)" />
        <b-img
          v-if="editable"
          v-b-tooltip.hover
          title="Delete"
          src="/img/icons/trash-icon.svg"
          class="asset-action-icon mx-2 my-1 my-lg-0"
          @click.stop="deleteFile(item)" />
      </div>
    </template>
  </b-table>
</template>

<script>
  export default {
    name: "FilesTable",
    props: {
      index: {
        type: Number,
        default: 0,
      },
      path: {
        type: String,
        default: '/',
      },
      files: {
        type: Array,
        default: () => [],
      },
      loading: {
        type: Boolean,
        default: true,
      },
      filter: {
        type: String,
        default: null,
      },
      editable: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "name",
            label: "Name",
            sortable: true,
            thStyle: "width: 53%",
          },
          {
            key: "contentType",
            label: "Kind",
            sortable: true,
            thStyle: "width: 7%",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "bytes",
            label: "Size",
            sortable: true,
            thStyle: "width: 8%",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "lastModified",
            label: "Modified Date",
            sortable: true,
            thStyle: "width: 15%",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "actions",
            label: "",
            sortable: false,
            thStyle: "width: 12%",
          },
        ],
      }
    },
    methods: {
      preview(file) {
        this.$emit('preview', file)
      },
      download(url, name) {
        this.$emit('download', url, name)
      },
      deleteFile(file) {
        this.$emit('delete', file)
      },
      copyUrl(url) {
        this.$emit('copy-url', url)
      },
      onRowSelected(items) {
        this.$emit('asset-selected', this.index, items)
      },
      updatePath(path) {
        console.log(`updating path to ${this.index}, ${this.path}`)
        this.$emit('update-path', this.index, path)
      },
      isFolder(file) {
        return file.contentType === 'folder'
      },
    },
  }
</script>

<style scoped>
  .folder-icon {
    background-image: url(../../public/img/icons/folder-icon.svg);
    background-size: cover;
    display: inline-block;
    height: 15px;
    width: 15px;
    vertical-align: text-bottom;
  }

  .asset-action-icon {
    cursor: pointer;
    max-height: 16px;
    max-width: 16px;
  }

  div i.fas {
    transition: 0.1s transform ease-in-out;
  }

  img.thumbnail {
    max-height: 30px;
    max-width: 30px;
    transition: all 0.2s ease-in-out;
  }

  img.thumbnail:hover {
    cursor: pointer;
    transform: scale(1.2);
  }
</style>
